$(document).ready(function(){
  $('.slider-container').slick({
  dots: true,
  arrows: true,
  appendDots: $('.slider-pagination'), // sélectionnez ici la première div où vous voulez afficher la pagination
  dotsClass: 'slick-dots custom-dots', // ajout d'une classe personnalisée pour styliser les points de pagination
      customPaging: function(slider, i) {
    var romanNumeral = ['I', 'II', 'III'][i]; // Remplacez le tableau avec les chiffres romains pour chaque étape
    return '<button type="button">' + romanNumeral + '</button>';
  },
    infinite: false, // Autorise la navigation infinie
    speed: 500, // Vitesse de transition en millisecondes
    slidesToShow: 1, // Nombre de slides à afficher en même temps
    slidesToScroll: 1, // Nombre de slides à faire défiler à chaque fois
    autoplay: false, // Active l'autoplay
    autoplaySpeed: 5000, // Vitesse de transition en mode autoplay
    prevArrow: ' <div class="prev-arrow"> <svg version="1.1" id="arrow-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490.787 490.787" style="enable-background:new 0 0 490.787 490.787;" xml:space="preserve"><path style="fill:#F44336;" d="M362.671,490.787c-2.831,0.005-5.548-1.115-7.552-3.115L120.452,253.006c-4.164-4.165-4.164-10.917,0-15.083L355.119,3.256c4.093-4.237,10.845-4.354,15.083-0.262c4.237,4.093,4.354,10.845,0.262,15.083c-0.086,0.089-0.173,0.176-0.262,0.262L143.087,245.454l227.136,227.115c4.171,4.16,4.179,10.914,0.019,15.085C368.236,489.664,365.511,490.792,362.671,490.787z"/><path d="M362.671,490.787c-2.831,0.005-5.548-1.115-7.552-3.115L120.452,253.006c-4.164-4.165-4.164-10.917,0-15.083L355.119,3.256c4.093-4.237,10.845-4.354,15.083-0.262c4.237,4.093,4.354,10.845,0.262,15.083c-0.086,0.089-0.173,0.176-0.262,0.262L143.087,245.454l227.136,227.115c4.171,4.16,4.179,10.914,0.019,15.085C368.236,489.664,365.511,490.792,362.671,490.787z"/></svg></div>',
    nextArrow: '<div class="next-arrow"><svg version="1.1" id="arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490.8 490.8" style="enable-background:new 0 0 490.8 490.8;" xml:space="preserve"><style type="text/css">.st0{fill:#F44336;}</style><path class="st0" d="M128.1,0c2.8,0,5.5,1.1,7.6,3.1l234.7,234.7c4.2,4.2,4.2,10.9,0,15.1L135.7,487.5c-4.1,4.2-10.8,4.4-15.1,0.3c-4.2-4.1-4.4-10.8-0.3-15.1c0.1-0.1,0.2-0.2,0.3-0.3l227.1-227.1L120.6,18.2c-4.2-4.2-4.2-10.9,0-15.1C122.6,1.1,125.3,0,128.1,0z"/><path d="M128.1,0c2.8,0,5.5,1.1,7.6,3.1l234.7,234.7c4.2,4.2,4.2,10.9,0,15.1L135.7,487.5c-4.1,4.2-10.8,4.4-15.1,0.3c-4.2-4.1-4.4-10.8-0.3-15.1c0.1-0.1,0.2-0.2,0.3-0.3l227.1-227.1L120.6,18.2c-4.2-4.2-4.2-10.9,0-15.1C122.6,1.1,125.3,0,128.1,0z"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  
  $('.slider-container-cocktails').slick({
  dots: false,
  arrows: true,
    infinite: false, // Autorise la navigation infinie
    speed: 500, // Vitesse de transition en millisecondes
    slidesToShow: 1, // Nombre de slides à afficher en même temps
    slidesToScroll: 1, // Nombre de slides à faire défiler à chaque fois
    autoplay: false, // Active l'autoplay
    autoplaySpeed: 5000, // Vitesse de transition en mode autoplay
      prevArrow: $('.custom-arrows .prev-arrow'),
  nextArrow: $('.custom-arrows .next-arrow'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

    $('.slider-container, .slider-container-cocktails').on('afterChange', function(event, slick, currentSlide){
  var lastSlide = slick.slideCount - 1;
  if(currentSlide === lastSlide){
    $('.slick-next').addClass('slick-disabled');
  } else {
    $('.slick-next').removeClass('slick-disabled');
  }
});

  /* legal page remove if cookie ok */
if ($('#prompt-background').is(':hidden')) {
    $('#prompt-background').remove();
    $('body').removeClass('overfloww');
  
} else {
    $('body').addClass('overfloww');
}

  /*effet transition smooth chargement page*/
  
  $(window).on("load", function() {
  $("body").addClass("loaded");
});


});


// fonction pour activer ou désactiver la musique de la vidéo Vimeo
function toggleMusic(state) {
  // récupérer l'iframe de la vidéo
  var iframe = document.getElementById("vimeo-video");

  // récupérer l'objet player de la vidéo Vimeo
  var player = new Vimeo.Player(iframe);

  // activer ou désactiver la musique en fonction de l'état
  if (state === "on") {
    player.setVolume(1); // mettre le volume à 100%
        musicControl.innerHTML = '<svg id="wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05"> <title>Audio on</title> <path id="Line_1" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/> <path id="Line_2" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"/> <path id="Line_3" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"/> <path id="Line_4" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"/> <path id="Line_5" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"/> <path id="Line_6" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"/> <path id="Line_7" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"/> <path id="Line_8" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"/> <path id="Line_9" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"/></svg>';
    toggleMusic("on");
  } else {
    player.setVolume(0); // mettre le volume à 0%
        musicControl.innerHTML = '<svg version="1.1" id="audio-off" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><title>Audio off</title><g><path d="M256,223.5c-79.7,0-144.3,64.6-144.3,144.2S176.3,512,256,512c79.7,0,144.3-64.6,144.3-144.2c0,0,0,0,0,0C400.1,288.1,335.6,223.6,256,223.5z M386,367.8c-0.1,71.8-58.2,129.9-130,130c-71.8,0-130-58.2-130-130c0-71.8,58.2-130,130-130C327.8,237.7,386,295.9,386,367.8C386,367.7,386,367.7,386,367.8z"/><path d="M313.4,304.3c-1.3-1.1-3-1.6-4.7-1.4l-81.9,11.7c-2.9,0.4-5,2.9-5,5.8v23.4v45.2c-3.5-2-7.5-3.2-11.8-3.2c-12.9,0-23.5,10.5-23.5,23.5c0,12.9,10.5,23.5,23.5,23.5c12.9,0,23.5-10.5,23.5-23.5v-60.4l70.2-10v38.4c-3.5-2-7.5-3.2-11.8-3.2c-12.9,0-23.5,10.5-23.5,23.5S279,421,291.9,421s23.5-10.5,23.5-23.5v-65.5v-23.4C315.4,307,314.7,305.4,313.4,304.3z"/></g></svg>';
    toggleMusic("off");
  }
}


